/**
 * ORP offset by core length in grapheme clusters (PRD §7, single source):
 * 1→0, 2–5→1, 6–8→2, 9–11→3, 12–14→4, 15+→5.
 */
export const ORP_TABLE = [
    { maxCoreLen: 1, offset: 0 },
    { maxCoreLen: 5, offset: 1 },
    { maxCoreLen: 8, offset: 2 },
    { maxCoreLen: 11, offset: 3 },
    { maxCoreLen: 14, offset: 4 },
    { maxCoreLen: Infinity, offset: 5 },
];
export function orpOffset(coreLen) {
    for (const row of ORP_TABLE) {
        if (coreLen <= row.maxCoreLen)
            return row.offset;
    }
    return 0;
}
export function clusterCount(token) {
    return token.clusterToUnitOffsets.length - 1;
}
/**
 * Anchor cluster index within token.raw. The table walks from coreStart, so
 * leading punctuation never captures the anchor (PD-4); pure-punct tokens
 * center instead.
 */
export function orpCluster(token) {
    if (token.coreLen === 0) {
        return Math.floor((clusterCount(token) - 1) / 2);
    }
    return token.coreStart + orpOffset(token.coreLen);
}
//# sourceMappingURL=orp.js.map